import { User, UserRole } from '@/types';
import { UserItem } from './UserItem';
import { AddUserDialog } from './AddUserDialog';

interface UserListProps {
  users: User[];
  isAdmin: boolean;
  onAddUser: (userData: { username: string; phoneNumber: string; role: UserRole }) => void;
  onUpdatePhone: (userId: string, phoneNumber: string) => void;
  onUpdatePassword: (userId: string, password: string) => void;
  onDelete: (userId: string) => void;
  showAddDialog: boolean;
  setShowAddDialog: (show: boolean) => void;
}

export function UserList({
  users = [],
  isAdmin,
  onAddUser,
  onUpdatePhone,
  onUpdatePassword,
  onDelete,
  showAddDialog,
  setShowAddDialog,
}: UserListProps) {
  return (
    <>
      <div className="bg-white shadow-sm rounded-lg divide-y">
        {users.length === 0 ? (
          <p className="p-4 text-center text-gray-500">
            لا يوجد مستخدمين حالياً
          </p>
        ) : (
          users.map((user) => (
            <UserItem
              key={user.id}
              user={user}
              isAdmin={isAdmin}
              onUpdatePhone={onUpdatePhone}
              onUpdatePassword={onUpdatePassword}
              onDelete={onDelete}
            />
          ))
        )}
      </div>

      <AddUserDialog
        open={showAddDialog}
        onClose={() => setShowAddDialog(false)}
        onSubmit={onAddUser}
      />
    </>
  );
}